import { ArrowLeftLinearIcon } from '../../../icons-lib';
import { Box, MenuItem } from '@mui/material';
import i18n from '../../../i18';
import CustomCalendar from '../../../components/calendar/CustomCalendar';
import { formatFilterData } from '../../../utils/formatCalendar';
import moment from 'moment';
import Scrollbar from '../../../components/scrollbar';

export const FilterCalendar = ({
    selectedFilter,
    filters,
    field,
    onValueChange,
    onBack
}) => {
    const start = filters.find(
        (f) => f.field === field.id && f.op === '>'
    )?.value;
    const end = filters.find(
        (f) => f.field === field.id && f.op === '<'
    )?.value;
    const handleChangeCalendar = (value) => {
        const filterData = formatFilterData(
            value.startDate,
            value.endDate,
            field.id
        );
        onValueChange(filterData);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexShrink: 1,
                maxWidth: '100%',
                overflow: 'hidden',
                p: 0
            }}
        >
            <MenuItem onClick={onBack}>
                <ArrowLeftLinearIcon sx={{ mr: 2 }} />
                {i18n.t(`columns.${selectedFilter.label}`)}
            </MenuItem>
            <Scrollbar sx={{ maxHeight: 300, mt: 1 }}>
                <CustomCalendar
                    value={{
                        startDate: moment(start),
                        endDate: moment(end)
                    }}
                    onChange={(value) => {
                        handleChangeCalendar(value);
                    }}
                    shortcuts={[
                        {
                            label: 'today',
                            days: 1
                        },
                        {
                            label: 'thisWeek',
                            days: 7
                        },
                        {
                            label: 'thisMonth',
                            days: 30
                        }
                    ]}
                />
            </Scrollbar>
        </Box>
    );
};
